import EnrollmentAcknowledgement from "../../enrollmentAcknowledgement/EnrollmentAcknowledgement";
import { OpenEnrollment } from "../../../../../types/openEnrollment.types";
import { Plan } from "../../../../../types/plan.types";
import { useState, useEffect, useContext, useCallback, useMemo } from "react";
import {
	AlwaysOpenPlanAcknowledgementProps,
	PlanAcknowledgementProps
} from "../../../../../types/components/enrollmentProps.types";
import { EnrollmentSchema } from "../../../../../types/enrollment.types";
import { AuthContext, ThemeContext } from "../../../../../contexts";
import { Paper, Grid, Button } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { DISCLAIMER_WAIVED_DESCRIPTION } from "../../../../../constants/disclaimerText";
import { CustomAlertMessage } from "../../../../shared";

const AlwaysOpenPlanAcknowledgement = ({
	enrollments,
	planName,
	alwaysOpenEnrollments
}: AlwaysOpenPlanAcknowledgementProps): JSX.Element => {
	// console.log("plan name 333333 ==>", alwaysOpenEnrollments, "planName", planName, "enrollments", enrollments);

	const [alwaysOpenEnrollment, setAlwaysOpenEnrollment] = useState<Plan | null>(null);
	const { theme } = useContext(ThemeContext);
	const [enrollment, setEnrollment] = useState<EnrollmentSchema>();
	const { member } = useContext(AuthContext);
	const location = useLocation();
	const history = useHistory();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	// console.log("plan name 333333 66==>", alwaysOpenEnrollments, "planName", planName, "enrollments", enrollments);
	const filteredEnrollments = useMemo(() => {
		return enrollments.filter((e: EnrollmentSchema) => e.plan_name === planName);
	}, [enrollments, planName]);

	const findPlanAlwaysOpenEnrollment = useCallback(() => {
		if (!alwaysOpenEnrollments?.length) return;
		for (
			let alwaysOpenEnrollmentIdx = 0;
			alwaysOpenEnrollmentIdx < alwaysOpenEnrollments?.length;
			alwaysOpenEnrollmentIdx++
		) {
			const _alwaysOpenEnrollment = alwaysOpenEnrollments[alwaysOpenEnrollmentIdx];
			if (_alwaysOpenEnrollment.plan_name === planName) {
				setAlwaysOpenEnrollment(_alwaysOpenEnrollment);
				break;
			}
		}
	}, [alwaysOpenEnrollments, planName]);

	const findPlanEnrollment = useCallback(() => {
		if (!member) {
			return;
		}
		for (let enrollmentIdx = 0; enrollmentIdx < filteredEnrollments.length; enrollmentIdx++) {
			const _enrollment = filteredEnrollments[enrollmentIdx];
			// console.log("==_enrollment before=>", _enrollment);
			if (
				_enrollment.member_SSN === member.SSN &&
				_enrollment.insured_SSN === member.SSN &&
				_enrollment.plan_name === planName
			) {
				// console.log("==_enrollment after=>", _enrollment);
				setEnrollment(Object.assign({}, _enrollment));
				break;
			}
		}
	}, [member, planName, filteredEnrollments]);

	const handleEnrollAgainButtonClick = useCallback(() => {
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=1`);
	}, [history, urlSearchParams]);

	useEffect(() => {
		findPlanAlwaysOpenEnrollment();
		findPlanEnrollment();
	}, [findPlanEnrollment, findPlanAlwaysOpenEnrollment]);

	if (!enrollment) return <></>;

	return (
		<div className="paper-form-container">
			<Paper className="theme-border-radius paper-container" elevation={1}>
				{alwaysOpenEnrollment && enrollment ? (
					<EnrollmentAcknowledgement
						idCardAccessPointRequired={true}
						dependentChangePointRequired={true}
						carrierPhoneNo={"(555) 555-1234"}
						carrierWebsite={"brookshirebrothers.com"}
						planDocument={""}
						planName={alwaysOpenEnrollment.plan_name}
						addDependentLink={"/home/add-family-member"}
						planCode={alwaysOpenEnrollment.plan_code}
						removeDependentLink={""}
						status={enrollment.enrollment_status}
					/>
				) : null}
				<div className="theme-plan-section-margin" />
				{["SUBMITTED", "WAIVED", "ACTIVE", "WAIVED - WAITING FOR APPROVAL"].includes(
					enrollment?.enrollment_status
				) ? (
					<Grid container>
						<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
						<Grid item xl={4} lg={4} xs={12} md={12} sm={12}>
							<Button
								style={{
									backgroundColor: theme.button.background_color,
									color: theme.button.color,
									width: "100%"
								}}
								onClick={handleEnrollAgainButtonClick}
							>
								Enroll again
							</Button>
						</Grid>
						<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
					</Grid>
				) : null}
			</Paper>
		</div>
	);
};

export default AlwaysOpenPlanAcknowledgement;
